import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/reset.css';
import VueApexCharts from "vue3-apexcharts";
import WebSocketManager from './utils/WebSocketManager';



const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueApexCharts);
app.provide("webSocketNotification", new WebSocketManager())


app.mount('#app')
